/**
 * The header and drawer in their two states. Both are server-rendered for a
 * visitor with no council; this reads those values once, then follows
 * council-change: with a council the name, Change and Forget show, the logo
 * and Get quotes go to the council's page, and the lookup openers step aside.
 */

import { current, onChange, forget } from './council.js';

export default function initHeaderCouncil() {
	const header = document.querySelector('[data-awdd-header]');
	if (!header) return;

	const all = (sel) => Array.from(header.querySelectorAll(sel));
	const logo = header.querySelector('.lockup-link');
	const quote = header.querySelector('[data-awdd-quote]');
	const names = all('[data-awdd-council-name]');
	const only = all('[data-awdd-council-only]');
	const without = all('[data-awdd-no-council]');
	const changeFrom = all('[data-awdd-change-from]');

	// The server-rendered values, read once.
	const base = {
		logoHref: logo ? logo.getAttribute('href') : null,
		logoLabel: logo ? logo.getAttribute('aria-label') : null,
		quoteHref: quote ? quote.getAttribute('href') : null,
	};
	// The label reads "{site name}, home"; the council form swaps the tail.
	const siteName = base.logoLabel ? base.logoLabel.replace(/,\s*[^,]*$/, '') : '';

	const render = (council) => {
		only.forEach((el) => { el.hidden = !council; });
		without.forEach((el) => { el.hidden = Boolean(council); });
		names.forEach((el) => {
			el.textContent = council ? council.name : '';
			el.hidden = !council;
		});

		if (logo) {
			logo.setAttribute('href', council ? council.url : base.logoHref);
			if (base.logoLabel) logo.setAttribute('aria-label', council ? `${siteName}, ${council.short}` : base.logoLabel);
		}

		if (quote) {
			if (council) {
				quote.setAttribute('href', `${council.url.replace(/#.*$/, '')}#quote`);
				delete quote.dataset.awddDialogOpen;
			} else {
				quote.setAttribute('href', base.quoteHref);
				quote.dataset.awddDialogOpen = 'lookup';
			}
		}

		changeFrom.forEach((el) => {
			el.textContent = '';
			if (!council) return;
			const [before, after = ''] = (el.dataset.template || '').split('{council}');
			const name = document.createElement('span');
			name.className = 'notranslate';
			name.textContent = council.short;
			el.append(before, name, after);
		});
	};

	// A council page sets its own council on arrival, so leave it before
	// forgetting or the choice would be written straight back.
	header.querySelectorAll('[data-awdd-forget]').forEach((btn) => {
		btn.addEventListener('click', () => {
			if (typeof window.awddCloseMenu === 'function') window.awddCloseMenu();
			if (document.body.dataset.awddCouncil) window.location.assign(base.logoHref || '/');
			forget();
		});
	});

	render(current());
	onChange(render);
}
